module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "click": _vm.bodyPartClicked
    }
  }, [_c('v-menu', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "offset-y": "",
      "left": "",
      "nudge-bottom": 0
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticClass: "btn full-width",
          class: {
            outline: _vm.outline, disabled: _vm.disabled, hoverable: !_vm.disabled && _vm.menuOnly
          },
          staticStyle: {
            "display": "flex"
          }
        }, on), [_c('div', {
          directives: [{
            name: "ripple",
            rawName: "v-ripple",
            value: (!this.disabled),
            expression: "!this.disabled"
          }],
          ref: "textPart",
          staticClass: "text-part",
          class: {
            hoverable: !_vm.disabled && !_vm.menuOnly, clickable: !_vm.disabled, 'menu-only': _vm.menuOnly
          },
          on: {
            "click": _vm.textPartClicked
          }
        }, [_vm._t("default", [_vm._v("\n                " + _vm._s(_vm.buttonText) + "\n                ")])], 2), _vm._v(" "), _c('div', {
          directives: [{
            name: "ripple",
            rawName: "v-ripple",
            value: (!this.disabled),
            expression: "!this.disabled"
          }],
          staticClass: "button-part",
          class: {
            hoverable: !_vm.disabled && !_vm.menuOnly
          },
          on: {
            "click": _vm.buttonPartClicked
          }
        }, [_c('v-icon', {
          staticStyle: {
            "margin-right": "-2px",
            "margin-left": "-2px"
          }
        }, [_vm._v("mdi-menu-down")])], 1)])]
      }
    }], null, true),
    model: {
      value: (_vm.menuVisible),
      callback: function($$v) {
        _vm.menuVisible = $$v
      },
      expression: "menuVisible"
    }
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.menus), function(menu, i) {
    return _c('v-list-item', {
      key: i,
      on: {
        "click": function($event) {
          return _vm.emitClick(menu)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(menu.text))])], 1)
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c56009d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/SplitButton.vue
// module id = 2445
// module chunks = 1